export class MarketingVoucher {
    id = null;
    name = null;
    code = null;
    marketing = null;
    type = null;
    reducedAmount = null;
    reducedPercent = null;
    reducedMaxAmount = null;
    minCondition = null;
    note = null;
}